import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { DateError } from '../entities/date-errors.enum';
import { ShFormDateBaseComponent } from '../base-simple/form-date-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormDateComplexBaseComponent } from '../base-complex/form-date-complex-base.component';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-date',
    templateUrl: './form-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ShFormGroupComponent,
        NgIf,
        ShFormDateComplexBaseComponent,
        ReactiveFormsModule,
        NgClass,
        ShFormDateBaseComponent,
        AsyncPipe
    ]
})
export class ShFormDateComponent extends ShBaseFormComponent {
    @Input() autocomplete?: string;
    @Input() placeholder?: string;
    @Input() min?: string;
    @Input() max?: string;
    @Input() invalidFormatMsg?: string;
    @Input() invalidDateMsg?: string;
    @Input() minDateErrorKey: string = 'profile-form.date-input-field.min-date-error';
    @Input() maxDateErrorKey: string = 'profile-form.date-input-field.max-date-error';

    public internalErrorMessage: string | null = null;

    handleValidation(dateError: DateError): void {

        switch (dateError) {
            case DateError.InvalidDate:
                this.internalErrorMessage = this.invalidDateMsg || null;
                break;
            case DateError.InvalidFormat:
                this.internalErrorMessage = this.invalidFormatMsg || null;
                break;
            case DateError.MinDateError:
                this.internalErrorMessage =
                    this.translateService.translate(this.minDateErrorKey, { minDate: this.min }) || null;
                break;
            case DateError.MaxDateError:
                this.internalErrorMessage =
                    this.translateService.translate(this.maxDateErrorKey, { maxDate: this.max }) || null;
                break;
            default:
                this.internalErrorMessage = null;
                break;
        }

        if (this.internalErrorMessage) {
            this.control.setErrors({ message: this.internalErrorMessage });
        }
    }
}
